import { render, staticRenderFns } from "./Format0101.vue?vue&type=template&id=3a2e95c8&scoped=true"
import script from "./Format0101.vue?vue&type=script&lang=js"
export * from "./Format0101.vue?vue&type=script&lang=js"
import style0 from "./Format0101.vue?vue&type=style&index=0&id=3a2e95c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e95c8",
  null
  
)

export default component.exports